<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16dYRyy/tc-custom/9781613122327.jpg?1729082793592" alt="This image is the cover for the book Crown Maple Guide to Maple Syrup"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crown Maple Guide to Maple Syrup
      </h1>
      <p class="bookDescription body article font2">
        <b>Sixty-five sweet and savory recipes, plus tons of tips, trivia, and photos!</b><br/>  <br/> This is the ultimate guide to maple syrup, with sixty-five recipes, instructions on tapping and evaporating, and an overview of the fascinating history of maple syrup in the United States. Not just a cookbook, it offers a comprehensive look into the world of maple syrup, complete with archival images and tutorials on the process.<br/>  <br/> With recipes for maple-pecan sticky buns, maple-glazed duck, maple lemon bars, and much more, this beautifully illustrated guide comes from the producers of Crown Maple, a leading organic maple syrup—carried by gourmet food markets and used in many of the world’s best kitchens, including NoMad, Eleven Madison Park, Bouchon, Lincoln, and more.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robb Turner, Jessica Carbone, Tina Rupp
      </h2>
      
      <p class="authorDescription body article">Robb Turner is owner of Madava Farms in the Hudson River Valley, home to Crown Maple Syrup.<BR /><BR /> Jessica Carbone is a native New Englander and culinary writer, editor, and historian based in Washington, DC.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ABRAMS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06a9d258